import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class InvalidNipWarning extends Violation {
    public constructor() {
        super(ViolationSeverity.Warning, 'business.company.validation.other-seller.tax-identification-number');
    }
}
